module.exports = __webpack_public_path__ + "img/student_icon.f5084d9a.png";